/** Asks once whether visits may be counted (analytics cookie). Refusing is as easy as accepting. */
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";
import { setConsent, useConsent } from "@/lib/analytics";
import { go } from "@/features/public/PublicLayout";

export function CookieBanner() {
  const { open, consent } = useConsent();
  if (!open) return null;
  return (
    <section
      role="region"
      aria-label="Cookies"
      className="fixed inset-x-4 bottom-4 z-50 max-w-md rounded-xl border bg-card p-4 text-sm shadow-lg sm:left-4 sm:right-auto"
    >
      <h2 className="flex items-center gap-2 font-medium">
        <Cookie className="size-4 text-primary" aria-hidden /> Can we count your visit?
      </h2>
      <p className="mt-1.5 text-muted-foreground">
        One cookie keeps you signed in; it is needed. With your OK, we also count visits and which parts of BrainLog are used, to make it better. It stays with us: no
        advertising, nothing shared.{" "}
        <a
          href="/privacy"
          onClick={(e) => {
            e.preventDefault();
            go("/privacy#cookies");
          }}
          className="underline underline-offset-2 hover:text-foreground"
        >
          Details
        </a>
      </p>
      {consent && <p className="mt-1.5 text-xs text-muted-foreground">Your current choice: {consent === "accepted" ? "accepted" : "refused"}.</p>}
      <div className="mt-3 grid grid-cols-2 gap-2">
        <Button variant="outline" onClick={() => setConsent("refused")}>
          Refuse
        </Button>
        <Button variant="outline" onClick={() => setConsent("accepted")}>
          Accept
        </Button>
      </div>
    </section>
  );
}
